// action - snackbar
export const SNACKBAR_OPEN = '@snackbar/SNACKBAR_OPEN';
